<template>
	<div>
		<h4>Adicionales</h4>
		<b-form-row>

			<b-form-group
				class="col-md-2"
				label="Fecha reserva desde *"
			>
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.reservationStartDate
					}"
					reset-button
					size="sm"
					v-model="filters.reservationStartDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-2" label="Hasta *">
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.reservationEndDate
					}"
					reset-button
					size="sm"
					v-model="filters.reservationEndDate"
				/>
			</b-form-group>

			<b-form-group
				class="col-md-2"
				label="Fecha Ride desde *"
			>
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.serviceStartDate
					}"
					reset-button
					size="sm"
					v-model="filters.serviceStartDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-2" label="Hasta *">
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.serviceEndDate
					}"
					reset-button
					size="sm"
					v-model="filters.serviceEndDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Ride status">
				<multiselect
						:class="{'active-filter':filters.ridesStatus.length>0}"
						v-model="filters.ridesStatus"
						:options="statusOpts"
						group-label="group"
						group-values="options"
						group-select
						multiple
						label="text"
						track-by="value"
						placeholder="Todos"
						taggable
						size="sm"
				/>
			</b-form-group>
		</b-form-row>

		<b-form-row>
			<b-overlay :show="loadingExport" no-wrap rounded>
			</b-overlay>
			<b-col class="text-right mt-2">
				<b-button
					v-if="$hasPermission('report.show')"
					@click="search()"
					variant="primary"
					class="mr-2"
					><md-icon icon="search" /> Generar</b-button
				>
				<b-button
					v-if="$hasPermission('report.export.xls')"
					@click="excel()"
					variant="success"
					class="mr-2"
					><md-icon icon="" />Xls</b-button
				>
			</b-col>
		</b-form-row>

		<b-row>
			<div v-if="loading">
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
			</div>
			
			<b-col class="col-md-12 mt-4" v-if="!loading">
				<div class="table-responsive async-tables mt-3" v-if="showHtmlTable" >
					<b-row>
						<b-col>
							<span v-if="table.body.length>0">Mostrando {{(pagination.perPage>table.body.length)?table.body.length:pagination.perPage}} de {{table.body.length}} registros </span>
						</b-col>
						<b-col> 
							<b-pagination 
							class="float-right"
							v-model="pagination.currentPage"
							:total-rows="table.body.length"
							:per-page="pagination.perPage"
							aria-controls="my-table"
							>
							</b-pagination>
						</b-col>
					</b-row>
					
					<b-table  
					show-empty
					hover  
					:items="table.body" 
					:fields="table.header"
					id="my-table" 
					:current-page="pagination.currentPage" 
					:per-page="pagination.perPage">

					</b-table>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import api from "../../../../api.js";
import Multiselect from 'vue-multiselect';
export default {
	name: "comercial",
	components: {Multiselect},
	data() {
		return {
			currencyCode: "",
			loading: false,
			loadingExport: false,
			html: "",
			codeReport: "additionals",
			filters: {
				serviceStartDate: "",
				serviceEndDate: "",
				reservationStartDate: "",
				reservationEndDate: "",
				ridesStatus:[]
			},
			table:{
				body:[],
				header:[]
			},
			pagination:{
				currentPage:1,
				perPage:100
			},
			showHtmlTable:false
		};
	},
	methods: {
		search() {
			this.loading = true;
			this.showHtmlTable = false;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters
					}
				})
				.then(res => {

					this.showHtmlTable =true;
					this.table.body = res.data.body
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		excel() {
			this.loadingExport = true;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters,
						format: "excel"
					},
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "adicionales");
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loadingExport = false;
				});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts","transportServiceStatusOpts"]
		});
	},
	computed: {
		suppliersOpts() {
			return this.$root.auxVars.suppliersOpts;
		},
		statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts}]
		}
	}
};
</script>
